import styled from "styled-components";

export const CenterGridWrapper = styled.div`
    width: 100%;
    height: 60vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
        line-height: normal;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        overflow-y: scroll;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-row-group {
        background-color: #dddd00;
    }

    .ag-group-value {
        width: 100%;
    }

    .vh-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 26px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .vh-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .vh-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .vh-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;

export const AdminGridWrapper = styled.div`
    width: 100%;
    height: 74vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-row-group {
        background-color: #dddd00;
    }

    .ag-group-value {
        width: 100%;
    }

    .vh-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 26px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .vh-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .vh-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .vh-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;